// extracted by mini-css-extract-plugin
module.exports = {"table":"AddKidsTable_table__10Hgj","table__header":"AddKidsTable_table__header__5ftLi","table__subheader":"AddKidsTable_table__subheader__GBMYL"};